<template>
  <router-view v-if="$route.name.includes('Show')"/>
  <div v-else class="d-grid grid-col-1 grid-col-lg-1-2 gap-6">
    <div>
      <v-card class="shadow pa-5">
        <template v-if="statistic.length">
          <BaseWidget :items="statistic" circular class="mb-5"/>
          <BaseWidget :items="statistic"/>
        </template>
        <Plug v-else/>
      </v-card>
    </div>
    <TemplatePageGrid
      :items="workClientProjectsClientBillsGrid.grid.data"
      :page-data="workClientProjectsClientBillsGrid.grid"
    >
      <template slot="buttons">
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].client"
          :items="filter.client"
          v-model="selected.client"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].project"
          :items="filter.project"
          v-model="selected.project"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].weeks"
          :items="filter.week"
          v-model="selected.week"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['salary-table'].status"
          :items="filter.status"
          v-model="selected.status"
          item-value="status"
          placeholder="—"
          class="max-width"
        />
      </template>
      <BaseTableView :head="tableHead">
        <FinanceInvoiceWidgetTableItem
          v-for="(item, i) in signedReports"
          :key="i"
          :item="item"
        />
      </BaseTableView>
    </TemplatePageGrid>
  </div>
</template>

<script>
import TemplatePageGrid from "../../../components/templates/TemplatePageGrid";
import FinanceInvoiceWidgetTableItem from "../../../components/finance/invoice/FinanceInvoiceWidgetTableItem";
import BaseWidget from "../../../components/base/widget/BaseWidget";
import {mapActions, mapGetters} from "vuex";
import BaseTableView from "components/base/tableview/BaseTableView";
import Plug from "components/Plug";

export default {
  name: "invoiceWidget",
  components: {Plug, BaseTableView, BaseWidget, FinanceInvoiceWidgetTableItem, TemplatePageGrid},
  data: () => ({
    selected: {
      client: [],
      project: [],
      week: [],
      status: []
    }
  }),
  computed: {
    ...mapGetters('workClientProjectsClientBills', [
      'workClientProjectsClientBillStatuses',
      'workClientProjectsClientBillsGrid'
    ]),
    ...mapGetters(['companiesConfig']),
    tableHead() {
      return [
        {text: this.localStorage.translations.pages.finance['invoice-table'].project},
        {text: this.localStorage.translations.pages.finance['invoice-table'].registration_address},
        {text: this.localStorage.translations.pages.finance['invoice-table'].weeks},
        {text: this.localStorage.translations.pages.finance['invoice-table'].report},
        {text: this.localStorage.translations.pages.finance['invoice-table'].invoice},
        {text: this.localStorage.translations.pages.finance['invoice-table'].invoice_number},
        {text: this.localStorage.translations.pages.finance['invoice-table'].sum},
        {text: this.localStorage.translations.pages.finance['invoice-table'].created_at}
      ]
    },
    finSystem() {
      return this.companiesConfig['fin_system'] ? this.companiesConfig['fin_system'] : 'manual'
    },
    statusList() {
      return this.finSystem === 'manual'
        ? ['new', 'sent', 'paid_partly', 'paid']
        : ['new', 'import_in_progress', 'error', 'imported', 'sent', 'pending_payment', 'paid_partly', 'paid']
    },
    filter() {
      let result = {
        client: [],
        project: [],
        week: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
        status: []
      }
      for (let i in this.workClientProjectsClientBillsGrid.filter.clients) {
        result.client.push({
          id: i,
          name: this.workClientProjectsClientBillsGrid.filter.clients[i].name
        })
        for (let p in this.workClientProjectsClientBillsGrid.filter.clients[i].projects) {
          result.project.push({
            id: p,
            name: this.workClientProjectsClientBillsGrid.filter.clients[i].projects[p]
          })
        }
      }
      for (let i in this.statusList) {
        let t = this.workClientProjectsClientBillStatuses.filter(a => a.status === this.statusList[i])[0]
        result.status.push({
          name: this.localStorage.translations.pages.finance['invoice-status'][t.translation],
          status: t.status,
        })
      }
      return result
    },
    statistic() {
      let result = []
      this.workClientProjectsClientBillStatuses.forEach(element => {
          if (this.workClientProjectsClientBillsGrid.statistic.statuses[element.status] && this.workClientProjectsClientBillsGrid.statistic.statuses[element.status]['count'] > 0)
            result.push({
              name: this.localStorage.translations.pages.finance['invoice-status'][element.translation],
              color: element.color,
              count: this.workClientProjectsClientBillsGrid.statistic.statuses[element.status]['count'],
              text: this.$formatCurrency(this.workClientProjectsClientBillsGrid.statistic.statuses[element.status]['total_price']) + ' €'
            })
        }
      )
      return result
    },
    signedReports() {
      return this.workClientProjectsClientBillsGrid.grid.data.filter(item => Boolean(item['report_signed_at']))
    }
  },
  watch: {
    '$route.query'() {
      this.getPageData()
    },
    'selected.client'() {
      this.getPageData()
    },
    'selected.project'() {
      this.getPageData()
    },
    'selected.week'() {
      this.getPageData()
    },
    'selected.status'() {
      this.getPageData()
    },
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    ...mapActions('workClientProjectsClientBills', ['onWorkClientProjectsClientBillsGrid']),
    getPageData() {
      if (!this.$route.name.includes('Show'))
        this.onWorkClientProjectsClientBillsGrid({
          limit: this.$route.query.limit,
          page: this.$route.query.page,
          client: this.selected.client.join(','),
          project: this.selected.project.join(','),
          week: this.selected.week.join(','),
          status: this.selected.status.join(','),
        })
    },
  }
}
</script>

<style scoped lang="scss">
:deep() th, td {
  &:nth-child(1) {
    width: 250px;
  }

  &:nth-child(2) {
    width: 150px;
  }

  &:nth-child(3) {
    width: 100px;
  }

  &:nth-child(4) {
    width: 100px;
  }

  &:nth-child(5) {
    width: 100px;
  }

  &:nth-child(6) {
    width: 100px;
  }

  &:nth-child(7) {
    width: 150px;
  }

  &:nth-child(8) {
    width: 100px;
  }
}

.shadow {
  box-shadow: 0 4px 4px rgba(133, 133, 133, 0.25) !important;
  border-radius: 10px;
}
</style>
